import { useRecoilValue } from 'recoil';

import { sessionState } from '../../store/session/atom';

export const useValidateSuitability = () => {
  const { userProfile } = useRecoilValue(sessionState);
  const isManager = !!(userProfile?.isGestor && userProfile?.idTipoParceiro !== 4);

  const validateSuitability = (productProfile?: string, customerProfile?: string) => {
    const customerProfileLower = customerProfile?.toLowerCase();
    const productProfileLower = productProfile?.toLowerCase();

    const getSuitabilityValue = (perfil?: string) => {
      switch (perfil) {
        case 'arrojado':
        case 'dispensado':
          return 3;
        case 'moderado':
          return 2;
        case 'conservador':
          return 1;
        default:
          return 0;
      }
    };

    const productSuitabilityValue = getSuitabilityValue(productProfileLower);
    const customerSuitabilityValue = getSuitabilityValue(customerProfileLower);

    return customerSuitabilityValue >= productSuitabilityValue || isManager;
  };

  const validateQualified = (
    productIsQualified?: boolean,
    customerIsQualified?: boolean,
    customerIsProfessional?: boolean
  ) => {
    return (
      (!!productIsQualified && !!customerIsQualified) ||
      !productIsQualified ||
      !!customerIsProfessional
    );
  };

  const validateProfessional = (
    productIsProfessional?: boolean,
    customerIsProfessional?: boolean
  ) => {
    return (!!productIsProfessional && !!customerIsProfessional) || !productIsProfessional;
  };

  return {
    validateSuitability,
    validateQualified,
    validateProfessional,
  };
};
